import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import type {
  SendNotificationToCompanyRequestModel,
  SendNotificationToStudyGroupsRequestModel,
  SendNotificationToUsersRequestModel,
} from "@core/models/notifications/send-notification.model";
import { ResponseDataModel } from "@core/models/response-data.model";
import { RESOURCES } from "@shared/constants/resources.constants";
import { SKIP_LOADING } from "@core/consts/elusive-headers.constants";
import { ApiService } from "./api.service";

export interface NotificationsParams {
  pageNumber?: number;
  pageSize?: number;
}

@Injectable({
  providedIn: "root",
})
export class NotificationsService {
  private readonly apiService: ApiService = inject(ApiService);

  getNotifications(params: NotificationsParams): Observable<ResponseDataModel> {
    return this.apiService.get<ResponseDataModel>({
      route: RESOURCES.notifications,
      params,
      headers: SKIP_LOADING,
    });
  }

  updateReadNotification(notificationId: number): Observable<ResponseDataModel> {
    return this.apiService.post<ResponseDataModel>({
      route: RESOURCES.notificationRead(notificationId),
      headers: SKIP_LOADING,
    });
  }

  markAllReadNotifications(): Observable<ResponseDataModel> {
    return this.apiService.post<ResponseDataModel>({
      route: RESOURCES.notificationsMarkAllRead,
      headers: SKIP_LOADING,
    });
  }

  sendToUsers(body: SendNotificationToUsersRequestModel): Observable<ResponseDataModel> {
    return this.apiService.post<ResponseDataModel>({
      route: RESOURCES.notificationsSend,
      body,
    });
  }

  sendToStudyGroups(body: SendNotificationToStudyGroupsRequestModel): Observable<ResponseDataModel> {
    return this.apiService.post<ResponseDataModel>({
      route: RESOURCES.notificationsSendStudyGroups,
      body,
    });
  }

  sendToCompany(body: SendNotificationToCompanyRequestModel): Observable<ResponseDataModel> {
    return this.apiService.post<ResponseDataModel>({
      route: RESOURCES.notificationsSendCompany,
      body,
    });
  }
}
